import { ConfirmationStepView } from "./ConfirmationStepView";
import { readConfirmationContent } from "./content";
import { type StepProps } from "./taskRenderers";
import { useCompleteTaskV2 } from "./useCompleteTaskV2";

export const ConfirmationStep = ({ task, onComplete }: StepProps) => {
  const { completeTask, isPending } = useCompleteTaskV2();
  const { heading, description, confirmLabel, declineLabel, boxes } =
    readConfirmationContent(task.content);

  const handleSubmit = (hasAccepted: boolean) => {
    completeTask(
      {
        taskId: task.id,
        data: { capturedData: {}, hasAccepted },
      },
      { onSuccess: () => onComplete() },
    );
  };

  return (
    <ConfirmationStepView
      boxes={boxes}
      confirmLabel={confirmLabel}
      declineLabel={declineLabel}
      description={description}
      heading={heading}
      isSubmitting={isPending}
      onSubmit={handleSubmit}
    />
  );
};
